/**
 * Checks if a File object represents an audio file based on its MIME type.
 *
 * @param file - The File object to check
 * @returns True if the file's MIME type contains 'audio', false otherwise
 *
 * @example
 * ```typescript
 * const audioFile = new File([''], 'song.mp3', { type: 'audio/mpeg' })
 * const imageFile = new File([''], 'image.jpg', { type: 'image/jpeg' })
 *
 * isAudioFile(audioFile) // returns true
 * isAudioFile(imageFile) // returns false
 * ```
 */
export default function isAudioFile(file: File): boolean {
  return file.type.indexOf('audio') !== -1 ? true : false
}
